export { default } from './Entrevistes';
